import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import LawfirmModel from "../../models/lawfirm";

export default class LawFirmRepository extends BaseRepository {
  static modelClass = LawfirmModel;
  modelName = "lawfirm";
}
